import { CircleQuestionMark } from 'lucide-react';
import {
  AuthBrand,
  FirstLoginDialog,
  LoginForm,
  LoginMapPanel,
  useLoginScreen,
} from '@/features/auth';
import Notice from '@/shared/ui/Notice';

const SUPPORT_MAIL = 'mailto:support@movo-fleet.com?subject=Supporto%20accesso%20Movo%20Fleet';

export default function LoginPage() {
  const screen = useLoginScreen();

  return (
    <main className="flex min-h-screen flex-col bg-default lg:flex-row">
      <div className="flex w-full flex-col justify-center px-6 py-10 sm:px-10 lg:w-[42%] lg:max-w-xl lg:px-12 xl:px-16">
        <AuthBrand className="mb-10" />

        <div className="mb-8">
          <h1 className="text-hero-title text-strong">Accedi a Movo Fleet</h1>
          <p className="mt-2 text-body text-muted md:text-body-lg">
            Inserisci le tue credenziali per accedere.
          </p>
        </div>

        {screen.error && (
          <Notice tone="danger" className="mb-6">
            {screen.error}
          </Notice>
        )}

        <LoginForm
          defaultEmail={screen.defaultEmail}
          defaultRememberMe={screen.defaultRememberMe}
          submitting={screen.submitting}
          onSubmit={screen.submit}
        />

        <div className="mt-10">
          <div className="relative">
            <div className="absolute inset-0 flex items-center" aria-hidden>
              <div className="w-full border-t border-default" />
            </div>
            <div className="relative flex justify-center text-caption">
              <span className="bg-default px-3 text-subtle">Supporto</span>
            </div>
          </div>
          <p className="mt-6 flex items-start justify-center gap-2 text-center text-sm text-subtle">
            <CircleQuestionMark className="mt-0.5 h-4 w-4 shrink-0 text-placeholder" aria-hidden />
            <span>
              Problemi con l&apos;accesso?{' '}
              <a
                href={SUPPORT_MAIL}
                className="rounded-xs font-medium text-link underline focus-visible:focus-ring"
              >
                Contatta il supporto
              </a>
              .
            </span>
          </p>
        </div>
      </div>

      <LoginMapPanel />
      {screen.firstLoginDialog && <FirstLoginDialog {...screen.firstLoginDialog} />}
    </main>
  );
}
